import { takeEvery, put, call, fork } from 'redux-saga/effects';

import { Client } from '../../utils/client';
import { SEND_MFA, sendMFASuccess, sendMFAFailure, VERIFY_MFA, verifyMFASuccess, verifyMFAFailure, loginReset } from './actions';

export function* sendMFA(action) {
  const data = action.payload;

  if (data) {
    Client.setToken(data.jwtToken);
  }

  try {
    const otpData = yield call(Client.getData, '/portal/auth/otp?type=MFA');

    yield put(sendMFASuccess(otpData));
  } catch (error) {
    console.log(error);

    yield put(sendMFAFailure());
  }
}

export function* verifyMFA(action) {
  const data = action.payload;

  let verifyObject = Object.assign({}, data);

  verifyObject.type = 'MFA';

  try {
    const verifyData = yield call(Client.postData, '/portal/auth/otp', verifyObject);
    const cogToken = yield Client.getToken();

    if (verifyData.status) {
      if (verifyData.message && verifyData.message.mfaToken) {
        Client.setMFAToken(verifyData.message.mfaToken);
      }

      yield put(verifyMFASuccess(verifyData, cogToken));
    } else {
      console.log(verifyData);

      if (verifyData.statusCode === 400) {
        if (verifyData.message.includes('expired')) {
          yield put(verifyMFAFailure(true));
        } else {
          yield put(verifyMFAFailure());
        }
      } else {
        yield put(verifyMFAFailure());
      }
    }
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(loginReset());
    } else {
      yield put(verifyMFAFailure());
    }
  }
}

function* watchSendMFA() {
  yield takeEvery(SEND_MFA, sendMFA);
}

function* watchVerifyMFA() {
  yield takeEvery(VERIFY_MFA, verifyMFA);
}

export function* loginSaga() {
  yield fork(watchSendMFA);
  yield fork(watchVerifyMFA);
}
